export class EventView {
	constructor() {
		this.$popupModal = $("#js-popup-modal");
	}

	showEventOnPopup() {
		this.$popupModal.find(".modal-body").html($("#js-places"));
		this.$popupModal.find(".places").show();
		this.$popupModal.find(".places__top").show();

		$(".places__middle").append($(".js-stadium-zones"));
		$(".places__middle").append($(".js-places-prices"));

		this.$popupModal.addClass("modal_mobile-event");

		this.$popupModal.modal();
	}

	returnEventFromPopup() {
		$(".events_page").after($("#js-places"));

		$("#js-places-check-price").after($(".js-stadium-zones"));
		$("#js-places-check-price").after($(".js-places-prices"));

		$(".places__top").hide();
		this.$popupModal.find(".modal-body").html("");
		this.$popupModal.removeClass("modal_mobile-event");
		this.$popupModal.modal("hide");
	}

	showChildTicketInfo() {
		if (!localStorage.getItem("change_price_id_alert")) {
			const isSeason = $(".events_page").data("is-season");
			const word = isSeason ? "абонемент" : "билет";

			$("#js-alert-modal").find(".modal-body").html(`
					<h3>Обратите внимание!</h3>
					<p class="mb-0">Доступен ${word} для детей от 7 до 14 лет с 15% скидкой, приобрести его можно только в паре с обычным. </p>
					<label class="checkbox mt-4 mb-4 d-inline-flex">
              <input type="checkbox" name="show_price_id_alert_discount" class="checkbox__input" checked />
              <span class="checkbox__custom"></span>
              <span class="checkbox__block">Не показывать это сообщение</span>
          </label>
          <br>
          <button class="btn js-price-id-alert-btn" data-dismiss="modal">Продолжить</button>
				`);
			$("#js-alert-modal").modal();

			$(".js-price-id-alert-btn").on("click", () => {
				if ($("input[name='show_price_id_alert_discount']").is(":checked")) {
					localStorage.setItem("change_price_id_alert", "true");
				}
			});
		}
	}
}
